import './PizzaChart.css';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  ChartOptions,
  ChartData, 
  
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { ILineChartData } from '../../interfaces/type1/ILineChartData';
import { useRealoadOnThemeToogle } from '../hooks/useRealodOnThemeToogle';
import Color from '../../utils/Colors';
import { useColors } from '../hooks/useColors';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

export default function PizzaChart(props: {Data: ILineChartData}) {

    let fontColor = useRealoadOnThemeToogle();     
    let {getColors} = useColors();

    const data : ChartData<"pie">= {
        labels: props.Data.PieChartDataSet!.Data.Select(s => s.Group),        
        datasets: [{
            datalabels: {
                display: props.Data.PieChartDataSet!.ShowQuantity,
                color: fontColor,
                font:
                {
                    family: 'Oswald'
                },
                     
                formatter: function (value: any, item: any) {

                    if (props.Data.PieChartDataSet!.QuantityLabelFormatter)
                        return props.Data.PieChartDataSet!.QuantityLabelFormatter(props.Data.PieChartDataSet!.Data[item.dataIndex]);
                    else
                        return '';
                }
            },
            label: props.Data.PieChartDataSet!.Title,
            data: props.Data.PieChartDataSet!.Data.Select(s => s.Total),
            borderColor: getColors(props.Data.PieChartDataSet!.Data.Count()),
            backgroundColor: getColors(props.Data.PieChartDataSet!.Data.Count()),
            borderWidth: props.Data.PieChartDataSet!.Data.Count() > 1 ? 1 : 0,
        }],
    };

    
    const options: ChartOptions<"pie"> = {
        responsive: true,
        maintainAspectRatio: false, 
        plugins: {         
            tooltip: {
                enabled: props.Data.EnableTooltip ?? true,
                callbacks: {
                    title: (tooltipItems) => {                     
                      const labelIndex = tooltipItems[0].dataIndex; 
                      return `${data!.labels![labelIndex]}`; 
                    },
                    label: (tooltipItem) => {
                        const index = tooltipItem.dataIndex;
                        const total = data.datasets[0].data[index]; 
                        if(props.Data.ToolTipFormatter)
                        {
                            return props.Data.ToolTipFormatter(props.Data.PieChartDataSet!.Data[tooltipItem.dataIndex]);

                        }else{
                            return `Total ${total}`;
                        }
                       
                       
                    }
                  },
            },   
            legend: {
                display: props.Data.PieChartDataSet?.ShowLegends,
                labels: {
                    color: fontColor, 
                    font:
                    {
                        family: 'Oswald'
                    }
                },
            },
            title: {
                display: true,
                text: props.Data.PieChartDataSet!.Title,
                color: fontColor, 
                font:
                {
                    family: 'Oswald',
                    size: 19

                }

            },
        },
        scales: {
            x: {
                display: false
            },
            y: {
                display: false
            },
        },
    };


  return (
    <div className='PizzaChartComponent'>
      <Pie data={data} options={options} />
    </div>
  );
};

